import { withTranslation } from 'react-i18next';
import React, { Component } from 'react';
import Progress from "../Progress";
import i18next from "i18next";
import Api from "../../../lib/Api";
import MoreInfo from "../../../lib/MoreInfo";
import Loader from '../../Loader';

class Suspension extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: '',
			popUpText: ''
		};

		if (this.props.traject === 'race') {
			this.props.handler(1);
			this.props.goTo('/advice/image', this.props.traject);
		} else if (props.usage === '33' || props.usage === '34') {
			// always Fully
			this.setState({ value: 3 });
			this.props.handler(3);
			this.props.goTo('/advice/image', this.props.traject);
		}

		this.getSuspension = this.getSuspension.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.suspensionPopUp = this.suspensionPopUp.bind(this);
		this.closePopup = this.closePopup.bind(this);
		this.goBack = this.goBack.bind(this);


	}

	componentDidMount() {
		window.scrollTo(0, 0);

		this.getSuspension();
		i18next.on('languageChanged', () => { this.getSuspension() });

		if (this.props.suspension != null) {
			this.setState({ value: this.props.suspension });
		}
	}

	render() {
		if (typeof (this.state.data.data) !== "undefined") {
			var myArr = [];
			for (let v of Object.values(this.state.data.data)) {
				myArr.push([v.id, v.suspension, v.intro, v.intro2, v.image, v.cost, v.weight, v.maintenance, v.suitable, v.comfort]);
			}

			var typeID = this.props.type;
			var mtbType = this.props.mtbType;

			var subTitle = this.props.t('De vering heeft een grote invloed op de rijeigenschappen en prijs van een mountainbike');
			if (typeID === '1') {
				// subtitle Vlot
				subTitle = this.props.t('De vering heeft een grote invloed op de rijeigenschappen en prijs van een mountainbike');
			} else if (typeID === '2') {
				if (mtbType === 'Trail') {
					// subtitle Fun Trail
					subTitle = this.props.t('U heeft gekozen voor een trail bike');
				}
				if (mtbType === 'Fatbike') {
					// subtitle Fun Fatbike
					subTitle = this.props.t('Fatbikes hebben meestal geen vering (rigid) of enkel voorvering (hardtail) omdat de dikke banden de meeste schokken opvangen');
				}
				if (mtbType === 'Parkbike') {
					// subtitle Fun Parkbike
					subTitle = this.props.t('Nu niet van toepassing');
				}
			} else if (typeID === '3') {
				// subtitle Uitdagend
				subTitle = this.props.t('U wilt in de bergen gaan fietsen. Een full suspension mountainbike wordt hiervoor aangeraden. Bij beperkt budget en/of goede daal techniek kan een hardtail overwogen worden');
			}

			let handleChange = this.handleChange;
			var suspension = this.props.suspension;
			if (this.state.value !== undefined) {
				suspension = this.state.value;
			}

			let props = this.props;
			var indents = myArr.map(function (item, i) {


				if (parseInt(suspension, 8) === item[0]) {
					return (
						<div id={i} key={item[0]} className={"col-sm-4 option option-" + item[0]}>
							<div className="option-inner">

								<div className="text-center">
									<h3>{item[1]}</h3>
									<span>{item[2]}</span>

									<img className="img-responsive" src={"/img/" + item[4] + ".png"} alt={item[4]} />

									<span>{item[3]}</span>
								</div>

								<div className="info">
									<strong>{props.t('Extra kosten door vering')}</strong>
									<span>{item[5]}</span>
								</div>

								<div className="info">
									<strong>{props.t('Extra gewicht door vering')}</strong>
									<span>{item[6]}</span>
								</div>

								<div className="info">
									<strong>{props.t('Onderhoud')}</strong>
									<span>{item[7]}</span>
								</div>

								<div className="info infoBig">
									<strong>{props.t('Geschikt voor')}</strong>
									<span>{item[8]}</span>
								</div>

								<div className="info">
									<strong>{props.t('Comfort')}</strong>
									<span>{item[9]}</span>
								</div>

								<div className="text-center">
									<input type="radio" name="suspension" checked value={item[0]} onChange={handleChange} />
								</div>
							</div>
						</div>
					);
				} else {
					return (
						<div id={i} key={item[0]} className={"col-sm-4 option option-" + item[0]}>
							<div className="option-inner">

								<div className="text-center">
									<h3>{item[1]}</h3>
									<span>{item[2]}</span>

									<img className="img-responsive" src={"/img/" + item[4] + ".png"} alt={item[4]} />

									<span>{item[3]}</span>
								</div>

								<div className="info">
									<strong>{props.t('Extra kosten door vering')}</strong>
									<span>{item[5]}</span>
								</div>

								<div className="info">
									<strong>{props.t('Extra gewicht door vering')}</strong>
									<span>{item[6]}</span>
								</div>

								<div className="info">
									<strong>{props.t('Onderhoud')}</strong>
									<span>{item[7]}</span>
								</div>

								<div className="info infoBig">
									<strong>{props.t('Geschikt voor')}</strong>
									<span>{item[8]}</span>
								</div>

								<div className="info">
									<strong>{props.t('Comfort')}</strong>
									<span>{item[9]}</span>
								</div>

								<div className="text-center">
									<input type="radio" name="suspension" value={item[0]} onChange={handleChange} />
								</div>
							</div>
						</div>
					);
				}
			});

			return (
				<div className="container main">
					<div className="popup-container">
						<div className="popup">
							<p>{this.state.popUpText}</p>
							<button className="marginright btn btn-default" onClick={this.closePopup}>{this.props.t('Keuze aanpassen')}</button>
							<button className="btn btn-secondary" onClick={this.handleSubmit}>{this.props.t('OK')}</button>

						</div>
					</div>
					<div className="info-overlay"></div>
					<div className="more-info">
						<i className="closeInfo fas fa-times"></i>
						<div className="more-info-container"></div>
					</div>

					<Progress goTo={this.props.goTo} step={1} traject={this.props.traject} />


					<form className="suspension" onSubmit={this.handleSubmit}>
						<div className="row">
							<div className="col-12 text-center title">
								<h2>{this.props.t('Welke vering wil je op je mountainbike?')}</h2>
								<span className="sub-title">{subTitle}<span className="moreInfo link" onClick={() => { MoreInfo.show('info', 'suspension') }}><i className="fas fa-caret-right"></i> {this.props.t('More info')}</span></span>

							</div>
						</div>
						<div className="row justify-content-center">
							{indents}
						</div>
						<div className="row">
							<div className="col-6 text-left">
								<button className="back btn btn-link" onClick={this.goBack}><i className="fas fa-caret-left"></i> {this.props.t('Terug naar vorige stap')}</button>
							</div>
							<div className="col-6 text-right">
								<input id="submitbtn" className="btn btn-secondary" type="submit" value={this.props.t('Volgende')} />
							</div>
						</div>
					</form>
				</div>
			);

		} else {
			return <Loader />;
		}
	}

	getSuspension() {
		Api.get('/suspension').then(response => {
			this.setState({ data: response.data }, () => this.suspensionPopUp())
		})
	}

	handleChange(event) {
		this.setState({ value: event.target.value });
		document.getElementById("submitbtn").disabled = false;
	}

	handleSubmit(event) {
		event.preventDefault();
		if (this.state.value === undefined) {
			alert("please provide an answer");
		} else {

			this.props.handler(this.state.value)
				.then(() => this.props.goTo('/advice/image', this.props.traject));

		}

	}
	goBack(event) {
		event.preventDefault();
		this.props.goTo('/advice/speed', this.props.traject);
	}

	suspensionPopUp() {
		let text, value;
		switch (parseInt(this.props.usage, 10)) {
			case 11:
				value = 2;
				text = this.props.t('Voor eenvoudige paden');
				break;
			case 12:
				value = 2;
				text = this.props.t('Voor technische paden vlakke');
				break;
			case 13:
				value = 3;
				text = this.props.t('Voor technische paden hoogteverschil');
				break;
			case 21:
				value = 1;
				text = this.props.t('De meeste Fatbikes');
				break;
			case 22:
				value = 3;
				text = this.props.t('Bijna alle Trailbikes ons advies voor jou');
				break;
			case 23:
				value = 2;
				text = this.props.t('De meeste Dirtbikes');
				break;
			case 24:
				value = 2;
				text = this.props.t('Voor gewoon lekker');
				break;
			case 31:
				value = 3;
				text = this.props.t('Voor gebruik in');
				break;
			case 32:
			default:
				value = 3;
				text = this.props.t('Bijna alle Trailbikes sterk aan te raden');
				break;
		}
		this.setState({ value, popUpText: text });
	}

	closePopup() {
		window.$('.popup-container').hide();
	}
}

export default withTranslation('suspension')(Suspension);
